import React from 'react';
import quote from '../../assets/images/quotes/quote.png';
import quoteReversed from '../../assets/images/quotes/reversed-quote.png';
import i1next from 'i18next';
import i18next from 'i18next';
function Word() {
    return (
        <>
            {i18next.language === 'ar' ? (
                <div className='head-word'>
                    <h1>كلمة رئيس مجلس الإدارة</h1>
                    <img src={quote} alt={quote} className='q-top' />
                    <h5>
                        بتوجيهات كريمة من خادم الحرمين الشريفين الملك سلمان بن
                        عبد العزيز آل سعود -حفظه الله-، ومتابعة سمو ولي عهده
                        الأمين صاحب السمو الملكي الأمير محمد بن سلمان بن عبد
                        العزيز آل سعود -حفظه الله-، انطلقت رؤية المملكة 2030م مع
                        برنامج التحول الوطني 2020م لتشكل بداية مرحلة جديدة في
                        مسيرة المملكة للمستقبل.
                    </h5>
                    <h5 className='mt-2'>
                        إن حكومتنا الرشيدة حريصة على الاهتمام بالتنمية
                        الاجتماعية لكل المواطنين في هذا البلد المعطاء، متماشيةً
                        مع أهداف التنمية المستدامة 2030 والتي وضعتها الأمم
                        المتحدة، والتي تؤكد على تمكين الأشخاص ذوي الإعاقة ليصلوا
                        إلى أقصى درجات استقلاليتهم ودمجهم المجتمعي، وتجسيدا لروح
                        التعاون البنّاء والمسؤولية الاجتماعية بين القطاعين الخاص
                        والعام، جاءت فكرة تأسيس مركز التميز للتوحّد في المملكة
                        ليحدث نقلة نوعية في تقديم خدمات تأهيلية عالية المستوى
                        للأطفال والراشدين من ذوي اضطراب التوحّد، وتدريب الأسر
                        ورفع مستوى الوعي المجتمعي حول هذا الاضطراب، وتقديم برامج
                        التطوير المهني للممارسين وإجراء ودعم البحوث التطبيقية،
                        إضافةً إلى تقديم خدمات التأهيل المهني والحلول السكنية
                        لذوي اضطراب طيف التوحّد.
                    </h5>
                    <h5 className='mt-2'>
                        وإكمالا لهذا التوجه، فقد وقعت وزارة الموارد البشرية
                        والتنمية الاجتماعية مع مؤسسة النقد السعودي اتفاقية تأسيس
                        هذا المركز بدعم سخي من جميع البنوك السعودية في المملكة
                        ليكون بمثابة جهة اعتبارية مستقلة تعنى بالاهتمام والتطوير
                        لذوي اضطراب طيف التوحّد في المملكة والارتقاء بمستوى
                        الخدمات التي يقدمها ليكون صرحا يفتخر به في المملكة
                        والعالم أجمع.
                    </h5>
                    <h5 className='mt-2'>
                        إننا نفخر اليوم بمركز التميز للتوحّد بإنجازاتنا وكوادرنا
                        الوطنية المؤهلة، ونتطلع بثقة إلى مستقبل أكثر إشراقاً
                        تبنيه أيادينا وتجني ثماره أجيال الغد.‬
                    </h5>
                    <img src={quoteReversed} alt={quote} className='q-bot' />
                    <p>— ماجد بن عبدالرحيم الغانمي، رئيس مجلس الإدارة</p>
                </div>
            ) : (
                <></>
            )}
        </>
    );
}

export default Word;
